import { gql } from "@apollo/client";

export const CAN_REJECT_EVALUACION = gql`
query canRejectEvaluacion($idEvaluacion: Int!) {
    canRejectEvaluacion(idEvaluacion: $idEvaluacion) {
        valorEsperado
        success
        error
    }
  }
`;